import { render, staticRenderFns } from "./VServiceTaskTableRowHeader.vue?vue&type=template&id=1953a967&scoped=true&"
import script from "./VServiceTaskTableRowHeader.vue?vue&type=script&lang=ts&"
export * from "./VServiceTaskTableRowHeader.vue?vue&type=script&lang=ts&"
import style0 from "./VServiceTaskTableRowHeader.vue?vue&type=style&index=0&id=1953a967&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1953a967",
  null
  
)

export default component.exports